export const clearStorageExcept = (keysToKeep = [], env = 'localStorage') => {
  const storageEnv = window[env]
  const keys = Object.keys(storageEnv)
  for (const key of keys) {
    if (!keysToKeep.includes(key)) {
      storageEnv.removeItem(key)
    }
  }
}